import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { Field } from "@/components/Field";
import { SlotPicker } from "@/components/SlotPicker";

export function BookVisitDialog({ open, onOpenChange, onBooked }) {
  const [reason, setReason] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto rounded-2xl" data-testid="book-visit-dialog">
        <DialogHeader><DialogTitle>Prenota una visita</DialogTitle></DialogHeader>
        {open && (
          <SlotPicker
            title="Scegli giorno e orario"
            emptyText="Al momento non ci sono orari liberi prenotabili online. Contatta lo studio per fissare una visita."
            loadSlots={() => api.get("/me/slots").then((r) => r.data)}
            book={(date, time) => api.post("/me/appointments", { date, time, reason }).then((r) => r.data.label)}
            onBooked={(label) => { toast.success("Visita prenotata", { description: label }); setReason(""); onOpenChange(false); onBooked(); }}
            extra={
              <Field label="Motivo (facoltativo)">
                <input className="field" maxLength={200} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Es. visita di controllo" data-testid="book-visit-reason-input" />
              </Field>
            }
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
